import StoresBulkIndex from './stores_bulk_index';

document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('.select-store-group-id') as HTMLSelectElement; // 店舗グループに紐づく店舗を出したり、隠したりする
  const block = document.getElementById('store_bulk_import_block'); // 全て選択、全て解除
  const storeBulkImportLoading = document.getElementById('store_bulk_import_loading') as HTMLElement;
  const hiddenTagArea = document.getElementById('store_bulk_import_render_hidden_tags') as HTMLElement;
  const storeBulkImportInner = document.querySelector('.store-bulk-import-inner') as HTMLElement; // 店舗を選択する際に表示されている部分
  if (select == null || block == null) {
    return;
  }

  type brandAttributes = { id: number, name: string }
  type resultBrand = { attributes: brandAttributes }
  type storeAttributes = { id: number, name: string, chirashiru_brand: resultBrand };
  type resultStore = { attributes: storeAttributes };
  type resultStores = { data: Array<resultStore> };

  const submitButton = document.querySelector('[type="submit"]') as HTMLButtonElement;

  const disabledSubmitButton = () => {
    submitButton.disabled = true;
  }

  const enabledSubmitButton = () => {
    submitButton.disabled = false;
  }

  const getStores = () => {
    const client = new StoresBulkIndex();
    client.getStores([]).then((data) => {
      renderStores((data as resultStores).data);
      setAllStoreIds((data as resultStores).data);
      hideLoading();
      enabledSubmitButton();
    });
  }

  const renderStores = (stores: Array<resultStore>) => {
    // 店舗名の重複
    var storeNames = new Array;
    [].forEach.call(stores, store => {
      const storeAttributes = (store as resultStore).attributes;
      storeNames.push(storeAttributes.name);
    });
    var duplicateStoreNames = storeNames.filter(function (x, i, self) {
      i;
      return self.indexOf(x) !== self.lastIndexOf(x);
    });
    const storeBulkImportAllStores = document.getElementById('store_bulk_import_all_stores') as HTMLElement;
    const inputName = storeBulkImportAllStores.dataset.inputName || '';
    [].forEach.call(stores, store => {
      const storeAttributes = (store as resultStore).attributes;
      const storeId = storeAttributes.id;
      const storeName = storeAttributes.name;
      const label = document.createElement('label');
      const htmlId = 'chirashiru_store_ids_' + storeId;
      label.setAttribute('for', htmlId);
      const input = document.createElement('input');
      input.classList.add('store-id-checkbox');
      input.setAttribute('id', htmlId);
      input.setAttribute('value', String(storeId));
      input.setAttribute('type', 'checkbox');
      input.setAttribute('name', inputName);
      const span = document.createElement('span');
      span.innerText = storeName;
      label.appendChild(input);
      label.appendChild(span);
      if (duplicateStoreNames.indexOf(storeName) != -1) {
        const brand = storeAttributes.chirashiru_brand;
        const brandAttributes = brand.attributes;
        const brandSpan = document.createElement('span');
        brandSpan.classList.add('brand-name');
        brandSpan.innerText = '(' + brandAttributes.name + ')';
        label.appendChild(brandSpan);
      }
      storeBulkImportAllStores.appendChild(label);
    });
  }

  const setAllStoreIds = (stores: Array<resultStore>) => {
    var allStoreIds = new Array;
    var index = 0;
    const optionAllStoreIds = document.getElementById('all_store_ids') as HTMLElement;
    [].forEach.call(stores, store => {
      index += 1;
      const storeAttributes = (store as resultStore).attributes;
      const storeId = storeAttributes.id;
      allStoreIds.push(storeId);
      if (stores.length == index) {
        optionAllStoreIds.setAttribute('value', allStoreIds.join(','));
        refreshStoreCheckboxes();
      }
    });
  }

  const hideLoading = () => {
    storeBulkImportLoading.style.display = 'none';
  }

  const showLoading = () => {
    storeBulkImportLoading.style.display = 'block';
  }

  const refreshStoreCheckboxes = () => {
    const checkboxes = document.querySelectorAll('.store-id-checkbox');

    select.addEventListener('change', () => {
      toggleStoreIdCheckBoxes();
      checkAll();
      updateStoreCounter();
    });

    const toggleStoreIdCheckBoxes = () => {
      const value = select.value;
      const storeIds = value.split(',');

      checkboxes.forEach(checkbox => {
        const includedInStoreIds = storeIds.indexOf((checkbox as HTMLInputElement).value) != -1;
        const checked = (checkbox as HTMLInputElement).checked;
        const explicitlyChecked =
          (checkbox as HTMLInputElement).dataset.explicitlyChecked == 'true';
        if ((checked && explicitlyChecked) || includedInStoreIds) {
          const { parentElement } = checkbox;
          if (parentElement) {
            parentElement.style.display = 'inline-block';
          }
        } else {
          const { parentElement } = checkbox;
          if (parentElement) {
            parentElement.style.display = 'none';
            // 表示されていない店舗にチェックは外す
            (checkbox as HTMLInputElement).checked = false;
          }
        }
      });
    };

    const setFirstSelectValue = () => {
      // ブラウザバックしてきた時に一番最初を選択させておく
      const options = select.children;
      const firstOption = options[0] as HTMLOptionElement;
      if (firstOption) {
        select.value = firstOption.value;
      }
    }

    setFirstSelectValue();
    toggleStoreIdCheckBoxes();

    const checkAllButton = document.querySelector('.all-check');
    const clearAllButton = document.querySelector('.all-clear');

    if (checkAllButton == null || clearAllButton == null) {
      return;
    }

    checkAllButton.addEventListener('click', () => {
      checkAll();
    });

    clearAllButton.addEventListener('click', () => {
      checkboxes.forEach(checkbox => {
        const { parentElement } = checkbox;
        if (parentElement?.style.display == 'inline-block') {
          (checkbox as HTMLInputElement).checked = false;
        }
      });
      updateStoreCounter();
    });

    const checkAll = () => {
      checkboxes.forEach(checkbox => {
        const { parentElement } = checkbox;
        if (parentElement?.style.display == 'inline-block') {
          (checkbox as HTMLInputElement).checked = true;
        }
      });
      updateStoreCounter();
    }

    const updateStoreCounter = () => {
      const storeCount = document.querySelector('.store-count');
      const checkedBoxes = document.querySelectorAll('.store-id-checkbox:checked');
      if (storeCount) {
        (storeCount as HTMLElement).innerHTML = String(checkedBoxes.length);
      }
    };

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('click', () => {
        if ((checkbox as HTMLInputElement).checked) {
          (checkbox as HTMLInputElement).dataset.explicitlyChecked = 'true';
        } else {
          (checkbox as HTMLInputElement).removeAttribute('data-explicitly-checked');
        }
      });
      checkbox.addEventListener('change', () => {
        updateStoreCounter();
      });
    });

    checkAll();
  }

  const doNotLoadStores = () => {
    return !(hiddenTagArea == null);
  }

  const hideInner = () => {
    storeBulkImportInner.style.display = 'none';
  }

  const showInner = () => {
    storeBulkImportInner.style.display = 'block';
  }

  const removeHiddenTagArea = () => {
    hiddenTagArea.remove();
  }

  if (doNotLoadStores()) {
    const renderStoreButton = hiddenTagArea.querySelector('.render-stores') as HTMLElement;
    renderStoreButton.addEventListener('click', () => {
      disabledSubmitButton();
      showInner();
      showLoading();
      getStores();
      removeHiddenTagArea();
    });
  }

  // 初期実行
  const initialize = () => {
    disabledSubmitButton();
    if (doNotLoadStores()) {
      // 表示速度を優先する場合には店舗一覧を取得しない
      hideLoading();
      hideInner();
      enabledSubmitButton();
    } else {
      getStores();
    }
  }
  initialize();
});
